import { useSelector } from 'react-redux'

import { selectDocumentDelegateName, selectFeature } from '.'

export const useDocumentDelegateName = (): string => useSelector(selectDocumentDelegateName)
export const useApplicationIntegrationEnabled = (): boolean => useSelector(selectFeature('ApplicationIntegration'))
